module.exports = __webpack_public_path__ + "img/xls.cec7307e.png";